import styled, { css, keyframes } from 'styled-components'
import {
  IconX,
  IconInfoCircle,
  IconChevronDown,
  IconSquare,
  IconMinimize
} from '@tabler/icons-react'
// @ts-ignore
import { Alert, Input as CustomInput, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap'
// @ts-ignore
import { Avatar, Button, Textarea } from 'dsm-react-lib'
import { Tooltip } from 'react-tooltip'

export const ChatWindowContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: var(--surface-bg);
  z-index: 1;
  width: 100%;
  margin-right: 0.5rem;
  overflow: hidden;
  height: 100%;
  transition: flex 0.7s ease-in-out, transform 0.7s ease-in-out;
`

export const ChatBotContainer = styled.div<{ $isDrawerMode: boolean }>`
  display: ${(props) => (props.$isDrawerMode ? 'block' : 'flex')};
  overflow: hidden;
  flex-direction: row;
  align-content: start;
  background-color: var(--surface-bg);
  position: relative;
  height: 100%;
`

export const ChatWindowTitle = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`

export const ChatWindowHeaderTitle = styled.h4`
  color: white;
  padding-left: 1rem;
  margin-bottom: 0;
`

export const ChatWindowHeaderCloseBtn = styled(IconX)<{
  mr?: string
  disabled?: boolean
  color?: string
}>`
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  color: ${(props) => props.color || 'white'};
  transition: transform 0.2s ease;
  margin: auto;
  margin-right: ${(props) => (props.mr ? props.mr : '8px')};
  outline: none !important;
  &:hover {
    transform: scale(1.2);
  }
`

export const ChatWindowHeaderHomeBtn = styled(IconMinimize)`
  cursor: pointer;
  color: ${(props) => props.color || 'white'};
  transition: transform 0.2s ease;
  margin: auto;
  outline: none !important;
  &:hover {
    transform: scale(1.2);
  }
`
export const ChatWindowHeaderMaximizeIcon = styled(IconSquare)`
  cursor: pointer;
  color: ${(props) => props.color || 'white'};
  transition: transform 0.2s ease;
  outline: none !important;
  margin: auto;
  &:hover {
    transform: scale(1.2);
  }
`

export const ChatWindowHeaderBtnContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`
export const BotAvatar = styled(Avatar)`
  flex: 0 0 auto;
  margin: 8px 8px 8px 0px;
`

export const ChatRoomContainer = styled.div<{ $isDrawerMode: boolean; $selectedMessage: any }>`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin: ${(props) => (props?.$selectedMessage ? '0 2%' : !props.$isDrawerMode ? '0 10%' : '')};
`

export const ChatRoomSub = styled.div<{ $isFullScreenMode: boolean; $isDrawerMode: boolean }>`
  ${(props) => props.$isFullScreenMode && !props.$isDrawerMode && 'padding: 0 10%;'}
  transition: padding 0.3s ease;
  padding: 0 0.5rem;
`

export const ScrollerDiv = styled.div`
  display: flex;
  justify-content: center;
  position: sticky;
  bottom: 2px;
`
export const ChatHistoryContainer = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;
  max-width: 900px;
  width: 100%;
  justify-self: center;
`
export const ChatHistoryItemContainer = styled.div<{
  $isbot: boolean
  $isBotLoading: boolean
}>`
  display: flex;
  flex-direction: row;
  margin-top: 0.3rem;
  justify-content: ${(props) => (props.$isbot ? 'flex-start' : 'flex-end')};
  max-width: ${(props) => (props.$isbot ? 'calc(100% - 40px);' : '100%')};
  align-items: start;
`

export const ChatHistoryItemSubContainer = styled.div<{
  $hasFullWidth?: boolean
}>`
  display: flex;
  ${(props) => props.$hasFullWidth && 'width: calc(100% - 92px);'}
  margin-left: 7px;
`

export const ChatHistoryItemBox = styled.div<{ $hasOnlyFile: boolean; $isBot: boolean }>`
  display: flex;
  flex-direction: column;
  width: -webkit-fill-available;
  align-items: ${(props) => (props.$isBot ? 'start' : 'end')};
`
export const StyledInfo = styled(IconInfoCircle)`
  cursor: pointer;
  color: var(--white);
  margin-left: 1rem;
  outline: none;
`

export const ChatHistoryItemBoxHeader = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 16px;
`

const slideInWithFade = keyframes` from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } `

export const ChatInputContainer = styled.div`
  width: -webkit-fill-available;
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 0.5rem;

  &:focus-within .send-button {
    display: flex;
    animation: ${slideInWithFade} 0.4s ease-in-out forwards;
  }
`

export const ChatInputAttach = styled.span`
  padding: 8px;
  display: flex;
  align-self: center;
  border-radius: 2px;
  &:hover {
    cursor: pointer;
    color: var(--color-secondary);
  }
`

export const InputAction = styled.div`
  width: -webkit-fill-available;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 15px 0 15px;
`

export const DocmodeElement = styled.div`
  background-color: rgb(127 133 150);
  color: white;
  width: -webkit-fill-available;
  padding: 5px 1rem;
  text-align: center;
  border-top-right-radius: 2rem;
  border-top-left-radius: 2rem;
  display: flex;
  gap: 10px;
  justify-content: center;
`

export const StyledInput = styled.div<{ $isFocused: boolean; $isEdit?: boolean }>`
  display: flex;
  flex-direction: ${(props) => (props.$isFocused ? 'column' : 'row')};
  width: -webkit-fill-available;
  margin: ${({ $isEdit }) => ($isEdit ? '0.3rem 0 0 0' : ' 0.5rem 0.7rem 0')};
`

export const ChatInputTypingIndicator = styled.div`
  max-height: 28px;
`

export const ChatInputText = styled(Textarea)<{ $bgColor?: string; $isEdit?: boolean }>`
  border: none !important;
  background-color: ${({ $bgColor }) => $bgColor || 'var(--surface-bg)'};
  min-height: auto !important;
  max-height: 40vh !important;
  resize: none;
  padding: ${({ $isEdit }) => ($isEdit ? '0' : '0.5rem 0')};
  width: 100% !important;
  outline: none !important;
  margin: ${({ $isEdit }) => ($isEdit ? '0' : '0.5rem 0')};
  overflow-y: auto;

  &::placeholder {
    color: var(--icon-muted);
  }

  &:focus {
    box-shadow: none !important;
  }
`

export const ChatFileDropZoneContainer = styled.div`
  width: -webkit-fill-available;
  margin: 0 8px;
`

export const ChatInputFileDiv = styled.div<{ $showDraggableArea: boolean }>`
  display: ${(props) => (props.$showDraggableArea ? 'none' : 'flex')};
  flex-direction: column;
`

export const ChatInputFieldContainer = styled.div`
  width: -webkit-fill-available;
  padding: 0 10px;
  border: none;
  border-radius: 30px;
  transition: height 0.36s ease;
  &:focus-within {
    outline: none;
    transition: all 0.2s 0s;
  }
  &:disabled {
    cursor: not-allowed !important;
  }
`

export const FileUploadButton = styled(Button)<{ color?: string; $bgColor?: string }>`
  display: flex;
  align-self: center;
  justify-content: center;
  border: none !important;
  width: 40px;
  height: 40px;
  padding: 8px !important;
  margin: 0px !important;
  color: var(--text-disabled);
  margin-left: 5px !important;
  background-color: transparent;
  border-radius: 50% !important;
  &:disabled {
    cursor: not-allowed !important;
  }
  &:hover {
    color: ${(props) => props.color} !important;
    background-color: ${(props) => props.$bgColor} !important;
  }
`

export const ChatFileUploadButton = styled(CustomInput)`
  display: flex;
  align-self: center;
  border: none !important;
  box-shadow: 0px 4px 6px var(--color-secondary-tint, #f6cdc8);
`
export const ChatAlertContainer = styled(Alert)`
  width: -webkit-fill-available;
`

export const ChatNewConversationButton = styled(Button)`
  position: sticky;
  bottom: 5px;
  margin-left: calc(50% - 62px);
  width: fit-content;
`

export const ChatDisclaimer = styled.span`
  text-align: center;
  font-size: 0.8rem;
`

export const ChatFileListContainer = styled.div<{ $previewMode?: boolean; $hasFiles?: boolean }>`
  display: ${(props) => (props.$hasFiles ? 'flex' : 'none')};
  flex-wrap: wrap;
  gap: ${(props) => (props.$previewMode ? '0' : '10px')};
  justify-content: ${(props) => (props.$previewMode ? '' : 'flex-end')};
  margin-left: ${(props) => (props.$previewMode ? '10px' : '0px')};
`

ChatFileListContainer.defaultProps = {
  $hasFiles: true
}

export const ChatFileContainer = styled.div<{ size?: string; $addMargin: boolean }>`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 0.75px solid var(--icon-muted);
  background-color: var(--surface-bg);
  margin: ${(props) => (props.$addMargin ? '5px' : '5px 0 0 0')};
  width: 220px;
  ${(props) =>
    props.size &&
    props.size === 'small' &&
    css`
      width: 140px;
      height: 35px;
      margin: 0;
    `}
`

const shine = keyframes`
  0% { left: -50%; }
  100% { left: 100%; }
`

export const FileProgressBar = styled.div<{ $color: string; $progress?: number }>`
  margin-left: 2px;
  height: 4px;
  border-radius: 0px !important;
  border-bottom-left-radius: 20px !important;
  position: relative;
  overflow: hidden;
  ${({ $progress, $color }) => css`
    background-color: var(${$color}) !important;
    width: calc(${$progress}% - 2px);
    ${$progress === 100 ? 'border-bottom-right-radius: 20px !important;' : ''}
  `}
  ${({ $progress }) =>
    $progress &&
    $progress < 100 &&
    css`
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: -50%;
        width: 50%;
        height: 100%;
        background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.6), transparent);
        transform: skewX(-25deg);
        animation: ${shine} 2s linear infinite;
      }
    `}
`

export const FileViewContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  align-items: flex-start;
  margin-left: 240px;
  margin-top: 40px;
`

export const FileName = styled.div<{ size?: string }>`
  padding: 1rem;
  ${(props) =>
    props.size &&
    props.size === 'small' &&
    css`
      font-size: 10px;
      padding: 0.5rem;
    `}
`

export const MediaContainer = styled.div<{ size?: string }>`
  border-right: 0.75px solid var(--icon-muted);
  width: 50px;
  height: 50px;
  border-radius: 0px !important;
  ${(props) =>
    props.size &&
    props.size === 'small' &&
    css`
      width: 35px;
      height: 35px;
    `}
`

export const MediaType = styled.span<{ size?: string }>`
  padding: 0.75rem;
  display: flex;
  align-items: center;
  font-weight: 600;
  height: 100%;
  ${(props) =>
    props.size &&
    (props.size === 'small' || props.size === 'medium') &&
    css`
      font-size: ${props.size === 'small' ? '9px' : '13px'};
      padding: ${props.size === 'small' ? '0.4rem' : '0.5rem'};
    `}
`

export const StopRespondingButton = styled(Button)`
  background-color: var(--surface-bg) !important;
`

export const StyledDropdownMenu = styled(DropdownMenu)`
  padding: 0 !important;
`

export const StyledDropdownItem = styled(DropdownItem)`
  width: -webkit-fill-available !important;
  :hover {
    background-color: var(--surface-muted) !important;
  }
`

export const StyledChevron = styled(IconChevronDown)<{ isActive?: boolean }>`
  margin-left: 0.5rem;
`

export const Header = styled.h4`
  color: var(--white);
  font-size: 18px;
  font-weight: bold;
`

export const Description = styled.div`
  color: var(--icon-muted);
  font-size: 13px;
`

export const ChatSubroomHeader = styled.div`
  display: flex;
  margin-bottom: 1rem;
  justify-content: end;
  gap: 2rem;
`

export const ChatSubroomHeaderAction = styled.div`
  display: flex;
  gap: 1rem;
`

export const ChatItemContainer = styled.div<{ isBot: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => (props.isBot ? 'flex-start' : 'flex-end')};
  max-width: ${(props) => (props.isBot ? 'calc(100% - 50px);' : '100%')};
  margin-bottom: 1rem;
  ${(props) => (props.isBot ? '' : 'margin-left: 40px;')}
  align-items: top;
`
export const StyledTooltip = styled(Tooltip)`
  border-radius: 6px !important;
  padding: 10px !important;
  max-width: 250px;
  text-align: center;
  z-index: 9999 !important;
`

export const InputImg = styled.img<{ size: string }>`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 5px;
  object-fit: cover;
`

export const InputImgContainer = styled.div<{ $addMargin: boolean }>`
  position: relative;
  border: 1px solid var(--theme-border);
  background-color: var(--surface-bg);
  border-radius: 5px;
  margin: 0;
  height: fit-content;
  width: fit-content;
  &:hover {
    .close-icon {
      display: flex;
    }
  }
`
export const StyledRemoveImg = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  display: none;
  cursor: pointer;
  background-color: var(--surface-bg);
  border: 1px solid var(--theme-border);
  border-radius: 50%;
  padding: 2px;
`

export const ImgOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  opacity: 0;
  border-radius: 5px;
  transition: opacity 0.3s ease;
  &:hover {
    opacity: 1;
  }
`

export const ImgViewIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
